<template>
  <div>
    <div v-if="cohort && cohort.length" class="ut-overflow-auto">
      <table class="md:ut-w-full ut-mx-0 ut-text-sm ut-text-left lead-cohorts-table">
        <lead-cohorts-table-head />
        <lead-cohorts-table-body :cohort="cohort" />
      </table>
    </div>
    <div v-else class="ut-py-6 ut-text-sm ut-text-neutral-400 ut-italic">
      There are no referrals in the {{ getBracketLabel() }} bracket.
    </div>
  </div>
</template>

<script>
import LeadCohortsTableHead from '@/components/LeadCohorts/LeadCohortsTableHead.vue';
import LeadCohortsTableBody from '@/components/LeadCohorts/LeadCohortsTableBody.vue';
import LeadCohortBracketType from '@/Mapper/LeadCohortBracketType';

export default {
  name: 'LeadCohortsTable',
  components: {
    LeadCohortsTableHead,
    LeadCohortsTableBody,
  },
  props: {
    cohort: { required: true },
    bracket: { required: true },
  },
  data() {
    return {
      leadCohortBracketType: LeadCohortBracketType,
    };
  },
  methods: {
    getBracketLabel() {
      switch (this.bracket) {
        case LeadCohortBracketType.upTo30:
          return '0-30 days';
        case LeadCohortBracketType.upTo60:
          return '31-60 days';
        case LeadCohortBracketType.upTo90:
          return '61-90 days';
        case LeadCohortBracketType.above90:
          return '91+ days';
        case LeadCohortBracketType.all:
          return 'current';
        default:
          throw new Error('Unhandled bracket');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.address {
  text-overflow: ellipsis;
}

@media (max-width: 768px) {
  .lead-cohorts-table {
    width: 700px;
  }
}
</style>
